import { createPanelComponent } from '@modules/src/panel/createPanelComponent'
import GameSignals from '../../signals/GameSignals'
import Facade from '../../Facade'

// Extend the live Facade singleton via prototype chain so F.model stays reactive.
// Object.create keeps all property reads live (including model which starts null).
const panelFacade = Object.create(Facade)
Object.defineProperty(panelFacade, 'currencySymbol', {
    get() { return (Facade as any).model?.initData?.player?.currency ?? '' },
    enumerable: true,
    configurable: true,
})

export const PANEL_COMPONENT = createPanelComponent({
    signals: GameSignals,
    facade: panelFacade,
    customSignals: {
        // Example: wire game-specific panel signals here.
        // buyBonusClicked: GameSignals.someGameSpecificSignal,
        // gambleClicked: GameSignals.someOtherGameSpecificSignal,
    },
})
